<template>
  <v-container>
    <div class="headline mt-3 text-center">Kanaljämförelse - Sveriges Radio</div>
    <chart class="mt-3" @data:loaded="dataLoaded"></chart>
  </v-container>
</template>
<script>
import Chart from "./../ChartLine.js";
export default {
  components: {
    Chart
  },
  data() {
    return {
      loaded: false
    };
  },
  methods: {
    dataLoaded() {
        console.log("I'm loaded here!")
    }
  }
};
</script>
<style>
</style>